import React, { useState } from "react";
import { Popover, Button } from "antd";
import "./style.scss";

const PRZConfirmationPopover = ({
  title,
  content,
  onConfirm,
  onCancel,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  confirmDisabled = false,
  trigger = "click",
  children,
}) => {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const handleCancel = () => {
    setVisible(false); // Close the popover
    if (onCancel) {
      onCancel(); // Call the provided onCancel function if any
    }
  };

  const handleConfirm = () => {
    setVisible(false); // Close the popover after confirmation
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Popover
      title={title}
      content={
        <div>
          {content}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Button onClick={handleCancel} style={{ marginRight: "10px" }}>
              {cancelButtonText}
            </Button>
            <Button
              type="primary"
              onClick={handleConfirm}
              disabled={confirmDisabled}
            >
              {confirmButtonText}
            </Button>
          </div>
        </div>
      }
      trigger={trigger}
      open={visible}
      onVisibleChange={handleVisibleChange}
    >
      <div onClick={() => setVisible(!visible)}>{children}</div>
    </Popover>
  );
};

export default PRZConfirmationPopover;
